
define('ajaxConsolidator',[ 'jquery', 'eteration/eteration-ajax', 'underscore' ],

function($, etrAjax, underscore) {

	var intervalToField;

	$('body').bind('keydown', function (){
		if ($('#portInputFrom').val() && $('#portInputFrom').val().length !== 0) {
			clearInterval(intervalToField);
		}
	});

	function withSuggestedLocationResponse(callbackFunction) {

		window.suggestedLocationRequestMetaData = window.suggestedLocationRequestMetaData || {
			'inprogress' : false,
			'callbacks' : []
		};

		//for brevity
		var reqData = window.suggestedLocationRequestMetaData;

		reqData.callbacks.push(callbackFunction);

		if (!reqData.inprogress) {

			reqData.inprogress = true;
			
			var suggestedLocationSettings = {
				app : 'app.ibs',
				disableLoader : true,
				disableErrorHandling : true,
				service : '/booking/location/suggest',
				callback : function(response) {
					if (response.data) {
						intervalToField = setInterval(function () {
							underscore.each(reqData.callbacks, function (callback) {
								callback(this)
							}, response.data);

						}, 1);
						setTimeout(function () {
							clearInterval(intervalToField);
						}, 3000);
					}
					window.suggestedLocationRequestMetaData = undefined;
				}
			};

			etrAjax.get(suggestedLocationSettings);
			
		}

	}

	return {
		withSuggestedLocationResponse : withSuggestedLocationResponse
	};

}

);
